import React, { useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import SvgBuilding from '@icons/building.svg?react';

interface ComponentProps {
  customerName: string;
  dataTestId?: string;
}

const CustomerNameTag: React.FC<ComponentProps> = ({ customerName, dataTestId }) => {
  const { tr } = useTranslationLgs();
  const [open, setOpen] = useState(false);

  return (
    <>
      <ButtonTag label={tr(`CustomerNameTag.title`, `Customer`)} value={customerName} icon={<SvgBuilding />} readonly={true} dataTestId={dataTestId} />
    </>
  );
};

export default CustomerNameTag;
